import React from 'react';
import PropTypes from 'prop-types';

const MonitorTopNav = (props) => {
  const {
    changeDomain,
    domain,
    changeTimeRange,
    timeRange,
    totalImagesCount,
    changePerPage,
    perPage,
  } = props;

  return (
    <div className="tal">
      <p className="dib mll mrs">Domain: </p>
      <select className="dib" onChange={changeDomain} value={domain}>
        <option value="All">All</option>
        <option value="otrapuse.lv">otrapuse.lv</option>
        <option value="lindoamor.ee">lindoamor.ee</option>
        <option value="tavomeile.lt">tavomeile.lt</option>
        <option value="lindoamor.com">lindoamor.com</option>
      </select>
      <p className="dib mll mrs">Time range: </p>
      <select className="dib" onChange={changeTimeRange} value={timeRange}>
        <option value="1-day">1 day</option>
        <option value="3-days">3 days</option>
        <option value="1-week">1 week</option>
        <option value="2-weeks">2 weeks</option>
        <option value="1-month">1 month</option>
        <option value="All">All</option>
      </select>
      <p className="dib mll mrs">{`Count: ${totalImagesCount}`}</p>
      <p className="dib mll mrs">Images per page: </p>
      <select className="dib mrl" onChange={changePerPage} value={perPage}>
        <option value="3">3</option>
        <option value="6">6</option>
        <option value="9">9</option>
        <option value="12">12</option>
        <option value="15">15</option>
        <option value="18">18</option>
        <option value="21">21</option>
        <option value="24">24</option>
        <option value="27">27</option>
        <option value="30">30</option>
      </select>
    </div>
  );
};

MonitorTopNav.propTypes = {
  changeDomain: PropTypes.func.isRequired,
  domain: PropTypes.string.isRequired,
  changeTimeRange: PropTypes.func.isRequired,
  timeRange: PropTypes.string.isRequired,
  totalImagesCount: PropTypes.number.isRequired,
  changePerPage: PropTypes.func.isRequired,
  perPage: PropTypes.number.isRequired,
};

export default MonitorTopNav;
